import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Button,
  Input,
  InputGroup,
  InputRightElement,
  TableContainer,
  Icon,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import { FiSearch, FiMonitor, FiArrowLeft } from "react-icons/fi";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar";
import Pagination from "../../Components/Common/Pagination";
import axios from "axios";
import { api_url } from "../../url";

const SIDEBAR_WIDTH = "240px";

const AllDeposite = () => {
  const [searchTrx, setSearchTrx] = useState("");
  const [selectedDeposit, setSelectedDeposit] = useState(null);
  const [deposits, setDeposits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [limit, setLimit] = useState(10);
  const toast = useToast();

  const fetchDeposits = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${api_url}/deposits/all`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search: searchTrx },
      });
      if (res.data.success) {
        setDeposits(res.data.deposits);
        setTotalPages(res.data.pagination.pages);
        setTotalEntries(res.data.pagination.total);
      }
    } catch (error) {
      toast({ title: "Error fetching deposits", status: "error" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeposits();
  }, [page, limit, searchTrx]);

  const handleShowDetail = (deposit) => {
    setSelectedDeposit(deposit);
  };

  const handleBack = () => {
    setSelectedDeposit(null);
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
  };

  const filteredDeposits = deposits;

  return (
    <>
      <Navbar />
      <Sidebar />
      <Box
        p={{ base: 4, md: 8 }}
        bg="#f8f9fd"
        minH="100vh"
        mt="80px"
        ml={{ base: 0, md: SIDEBAR_WIDTH }}
      >
        {selectedDeposit ? (
          <Box maxW="1000px" mx="auto">
            <Flex align="center" mb={6} justify="space-between">
              <Text fontSize="2xl" fontWeight="600" color="#344767">
                Deposit Details
              </Text>
              <Button leftIcon={<FiArrowLeft />} onClick={handleBack}>
                Back to List
              </Button>
            </Flex>

            <Box bg="white" borderRadius="12px" p={8} shadow="sm">
              <Table variant="simple">
                <Tbody>
                  <Tr>
                    <Td>User</Td>
                    <Td textAlign="right" fontWeight="bold">
                      {selectedDeposit.user?.username} ({selectedDeposit.user?.userId})
                    </Td>
                  </Tr>
                  <Tr>
                    <Td>Amount</Td>
                    <Td textAlign="right" fontWeight="bold">₹{selectedDeposit.amount}</Td>
                  </Tr>
                  <Tr>
                    <Td>Transaction ID</Td>
                    <Td textAlign="right">{selectedDeposit.transactionId}</Td>
                  </Tr>
                  <Tr>
                    <Td>Status</Td>
                    <Td textAlign="right">
                      <Badge colorScheme={selectedDeposit.status === "success" ? "green" : selectedDeposit.status === "pending" ? "orange" : "red"}>
                        {selectedDeposit.status.toUpperCase()}
                      </Badge>
                    </Td>
                  </Tr>
                  <Tr>
                    <Td>Date</Td>
                    <Td textAlign="right">{new Date(selectedDeposit.createdAt).toLocaleString()}</Td>
                  </Tr>
                </Tbody>
              </Table>
            </Box>
          </Box>
        ) : (
          <>
            <Flex justify="space-between" align="center" mb={8}>
              <Text fontSize="2xl" fontWeight="700" color="#344767">
                All Deposits
              </Text>
              <InputGroup size="md" maxW="300px">
                <Input
                  placeholder="Username / TRX"
                  value={searchTrx}
                  onChange={(e) => setSearchTrx(e.target.value)}
                  bg="white"
                />
                <InputRightElement>
                  <Icon as={FiSearch} />
                </InputRightElement>
              </InputGroup>
            </Flex>

            <Box bg="white" borderRadius="12px" shadow="sm" overflow="hidden">
              {loading ? (
                <Flex justify="center" p={10}><Spinner /></Flex>
              ) : (
                <TableContainer>
                  <Table variant="simple">
                    <Thead bg="#4c3cff">
                      <Tr>
                        <Th color="white">Gateway | Transaction</Th>
                        <Th color="white">Initiated</Th>
                        <Th color="white">User</Th>
                        <Th color="white">Amount</Th>
                        <Th color="white">Status</Th>
                        <Th color="white">Action</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {filteredDeposits.map((d) => (
                        <Tr key={d._id}>
                          <Td>
                            <Text fontWeight="bold">IMB Gateway</Text>
                            <Text fontSize="xs">{d.transactionId}</Text>
                          </Td>
                          <Td fontSize="sm">
                            {new Date(d.createdAt).toLocaleString()}
                          </Td>
                          <Td>
                            <Text fontWeight="bold">{d.user?.username}</Text>
                            <Text fontSize="xs">{d.user?.userId}</Text>
                          </Td>
                          <Td fontWeight="bold">₹{d.amount}</Td>
                          <Td>
                            <Badge colorScheme={d.status === "success" ? "green" : d.status === "pending" ? "orange" : "red"}>
                              {d.status.toUpperCase()}
                            </Badge>
                          </Td>
                          <Td>
                            <Button size="sm" leftIcon={<FiMonitor />} onClick={() => handleShowDetail(d)}>
                              Details
                            </Button>
                          </Td>
                        </Tr>
                      ))}
                      {filteredDeposits.length === 0 && (
                        <Tr>
                          <Td colSpan={6} textAlign="center">No deposits found</Td>
                        </Tr>
                      )}
                    </Tbody>
                  </Table>
                </TableContainer>
              )}
            </Box>

            {/* Pagination */}
            {!selectedDeposit && (
              <Pagination 
                currentPage={page}
                totalPages={totalPages}
                totalEntries={totalEntries}
                limit={limit}
                onPageChange={setPage}
                onLimitChange={handleLimitChange}
              />
            )}
          </>
        )}
      </Box>
    </>
  );
};

export default AllDeposite;
